import { render, staticRenderFns } from "./HeaderStock.vue?vue&type=template&id=c8bcebc6&scoped=true"
import script from "./HeaderStock.vue?vue&type=script&lang=js"
export * from "./HeaderStock.vue?vue&type=script&lang=js"
import style0 from "./HeaderStock.vue?vue&type=style&index=0&id=c8bcebc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bcebc6",
  null
  
)

export default component.exports